<div class="flex flex-column align-items-center justify-content-center py-6 px-4 notification">
  <button pButton
          type="button"
          icon="pi pi-check"
          class="p-button-rounded sc-green"></button>
  <div class="py-1 title3Font">{{ header }}</div>
  <div class="py-1 body2Font">{{ message }}</div>
</div>